<div class="period">
  @if (_serviceinterval1 || serviceinterval2) {
    <div class="period__dd" [style.left]="ddOffsetPx"><span>d.d.</span></div>
  }
  @if (serviceinterval1) {
    <app-serviceinterval-bar-graph
      [label]="headline1"
      [onset]="onset1"
      [months]="months1"
      [offset]="offset1"
      [serviceinterval]="serviceinterval1"
    ></app-serviceinterval-bar-graph>
  }
  @if (serviceinterval2) {
    <app-serviceinterval-bar-graph
      [label]="headline2"
      [onset]="onset2"
      [months]="months2"
      [offset]="offset2"
      [altbar]="true"
      [serviceinterval]="serviceinterval2"
    ></app-serviceinterval-bar-graph>
  }
</div>
